var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { TooltipApi } from "..";
var EventCardStatisticsIcon = /** @class */ (function (_super) {
    __extends(EventCardStatisticsIcon, _super);
    function EventCardStatisticsIcon(props) {
        var _this = _super.call(this, props) || this;
        _this.iconWrapperClasses = (_this.props.modifiers ? "" + _this.props.modifiers : "");
        return _this;
    }
    EventCardStatisticsIcon.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", __assign({ className: this.iconWrapperClasses, onClick: function (event) { _this.props.handler(event); } }, TooltipApi.getInstance().setMessage(this.props.tooltip)), this.props.children));
    };
    return EventCardStatisticsIcon;
}(React.Component));
export { EventCardStatisticsIcon };
//# sourceMappingURL=EventCardStatisticsIcon.js.map